import $ from 'jquery';

export class InfiniteLoop {
    constructor($container, firstSelector, secondSelector) {
        this.enableTabLoop($container, firstSelector, secondSelector);
    }

    enableTabLoop($container, firstSelector, secondSelector) {
        if ($container && $container.length && firstSelector && secondSelector) {
            let $firstGuard = $container.find('.tab-guard').first();
            let $secondGuard = $container.find('.tab-guard').last();
            $firstGuard.focus(function () {
                $container.find(firstSelector).last().focus();
            })
            $secondGuard.focus(function () {
                $container.find(secondSelector).first().focus();
            })
        }
    }
}
